import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import {
  themes,
  scrollTop,
  tableRowSize,
  defaultAllSelection,
  iconStyle,
} from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { showToast } from "services/utils/Status";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { AssignSftHeader } from "pages/Administration/AdministrationHeaders";
import { IndividualUserShiftGradeDetails } from "pages/Administration/AdministrationHeaders";
import { ViewAssignmentPanel } from "../Components/ViewAssignmentPanel";
import { BulkAssignmentPanel } from "../Components/BulkAssignmentPanel";
import comLogo from "../../../../../assets/img/brand/company_logo.png";
import { customGetAPI } from "services/utils/CustomAPI";
import { CompanyProgress } from "components/CustomComponents/CustomSlider";
import { tooltipStyleProps } from "services/constants/Styles";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { userShiftGradeHeader } from "pages/Administration/AdministrationHeaders";
import { setFilterApi } from "services/Redux/userManagament";
import {
  Typography,
  Box,
  Paper,
  IconButton,
  Drawer,
  Tooltip,
} from "@mui/material";
import {
  SwapHorizontalCircle,
  RemoveRedEye,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Add,
} from "@mui/icons-material";
import { EmployeeView } from "../EmployeeView";
import moment from "moment";
import { useSaveView } from "components/CustomComponents/useSaveView";

export const AssignShiftGrade = ({ setSelectedShiftItem, subModuleId }) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, userScreenAccess, topbarCompanyName, userDetails } = useSelector(
    (state) => state.tokenReducer,
  );

  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [shiftGradeDetails, setShiftGradeDetails] = useState([]);
  const [userData, setUserData] = useState({});
  const [updateData, setUpdateData] = useState(true);
  const [expendRowId, setExpendRowId] = useState(0);
  const [individualLoader, setIndividualLoader] = useState(false);
  const [expandDetails, setExapandDetils] = useState([]);
  const [expandItem, setExpandItem] = useState([]);
  const [triggerApi, setTriggerApi] = useState(false);
  const [showUserView, setShowUserView] = useState(true);
  const containerRef = useRef(null);
  const [isMovePanelOpen, setIsMovePanelOpen] = useState(false);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);
  const [userShiftGradeDetails, setUserShiftGradeDetails] = useState([]);
  const [gradeData, setGradeData] = useState([]);
  const [trigger, setTrigger] = useState(true);
  const [selectedComponet, setSelectedComponent] = useState("Employee View");
  let group_check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Shift",
    "Group Shift Grade",
  );

  let employee_check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Shift",
    "Employee Shift Grade",
  );

  const {
    result: shiftData,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}administration/shiftroster/userassignment/shiftgrade/employee/count/?company_id=${requestCompanyId}`,
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    if (shiftData?.length !== 0 && updateData) {
      setShiftGradeDetails(shiftData);
    }
  }, [shiftData, updateData]);

  const handleMoveShift = () => {
    setIsMovePanelOpen(true);
    setExpendRowId(0);
  };

  const handleViewShiftGrade = () => {
    setIsViewPanelOpen(true);
  };

  const handleCreateClosePanel = () => {
    setIsMovePanelOpen(false);
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      setIndividualLoader(true);
      const res = await customGetAPI(
        `${domain}administration/shiftroster/userassignment/shiftgrade/shift-grade-details/?department_id=${defaultAllSelection}&shift_grade_id=${expandItem?.id}&user_id=${defaultAllSelection}&company_id=${requestCompanyId}`,
      );
      if (res.ok) {
        setExapandDetils(res?.responseDetails?.data);
        setTriggerApi(false);
        setIndividualLoader(false);
      } else {
        setTriggerApi(false);
        setIndividualLoader(false);
      }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
    }
  }, [
    domain,
    expandItem?.id,
    expandItem.leave_group_id,
    expandItem.user_id,
    triggerApi, requestCompanyId
  ]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      showUserView
        ? setUserShiftGradeDetails(filteredData)
        : setShiftGradeDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage, showUserView],
  );

  const reportMetadata = useMemo(
    () => ({
      "Company Name": topbarCompanyName || "N/A",
      "Report Generated On": moment().format("DD/MM/YYYY HH:mm:ss"),
    }),
    [topbarCompanyName],
  );

  const activeShiftGradeHeaders = useMemo(
    () =>
      showUserView
        ? userShiftGradeHeader
        // The "Action" entry is the expand-arrow column, not a real data
        // column — it has no name to show/rename and must always render,
        // so it's excluded from the configurable saved-view header set.
        : AssignSftHeader.filter((header) => header.key !== "Action"),
    [showUserView],
  );

  const handleSavedViewChange = useCallback(() => {
    setPage(0);
  }, []);

  const handleRestoreScope = useCallback((scopeValue) => {
    const restoredUserView = scopeValue === "employee";
    setShowUserView(restoredUserView);
    setSelectedComponent(restoredUserView ? "Employee View" : "Group View");
  }, []);

  const { visibleHeaders, titleOverride, newButtonComponent } = useSaveView({
    domain,
    userId: userDetails?.id,
    subModuleId,
    storageKey: "shift_grade_assignment_saved_views",
    scope: showUserView ? "employee" : "group",
    fullHeaders: activeShiftGradeHeaders,
    screenAccess: showUserView ? employee_check_access : group_check_access,
    onRestoreScope: handleRestoreScope,
    onViewChange: handleSavedViewChange,
  });

  return updateData && loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Shift Grade
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Assign employees to grade with defined rules
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <IconButton
              sx={iconStyle}
              onClick={() => {
                if (showUserView ? employee_check_access : group_check_access) {
                  handleMoveShift();
                } else {
                  showToast(
                    "error",
                    `Access denied: You are not authorized to move shift grade`,
                  );
                }
              }}
            >
              <SwapHorizontalCircle sx={{ color: themes.primaryIndicator }} />
            </IconButton>
            <Tooltip
              title="New Shift Grade"
              arrow
              slotProps={tooltipStyleProps}
            >
              <IconButton
                sx={iconStyle}
                onClick={() => setSelectedShiftItem("Shift Grade")}
              >
                <Add sx={{ color: themes.primaryIndicator }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box>
          <Box sx={{ display: "flex", gap: 2, ml: 5 }}>
            <Box
              sx={{
                padding: "12px 24px",
                backgroundColor:
                  selectedComponet === "Employee View"
                    ? "white"
                    : "transparent",
                color:
                  selectedComponet === "Employee View"
                    ? "primary.main"
                    : "text.secondary",
                fontWeight: 600,
                cursor: "pointer",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                marginBottom: "-1px",
                "&:hover": {
                  backgroundColor:
                    selectedComponet === "Employee View"
                      ? "white"
                      : "transparent",
                },
              }}
              onClick={() => {
                setShowUserView(true);
                setSelectedComponent("Employee View");
                dispatch(setFilterApi(true));
              }}
            >
              Employee View
            </Box>
            <Box
              sx={{
                padding: "12px 24px",
                backgroundColor:
                  selectedComponet === "Group View" ? "white" : "transparent",
                color:
                  selectedComponet === "Group View"
                    ? "primary.main"
                    : "text.secondary",
                fontWeight: 600,
                cursor: "pointer",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                marginBottom: "-1px",
                "&:hover": {
                  backgroundColor:
                    selectedComponet === "Group View" ? "white" : "transparent",
                },
              }}
              onClick={() => {
                setShowUserView(false);
                setSelectedComponent("Group View");
                dispatch(setFilterApi(true));
              }}
            >
              Group View
            </Box>
          </Box>
        </Box>
        <Paper sx={{ width: "100%", height: "78vh" }}>
          <CustomFilter
            title={showUserView ? "Employee Records" : "Shift Grade Records"}
            titleOverride={titleOverride}
            filterHeaders={visibleHeaders}
            data={showUserView ? gradeData : shiftData}
            filteredData={
              showUserView ? userShiftGradeDetails : shiftGradeDetails
            }
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={
              showUserView ? employee_check_access : group_check_access
            }
            newButtonComponent={newButtonComponent}
            downloadFormats={["excel", "pdf", "csv"]}
            includeMetadata={true}
            metadata={reportMetadata}
          />

          {showUserView ? (
            <EmployeeView
              setShowTopBar={false}
              viewComponent={"ShiftGrade"}
              setIsViewPanelOpen={setIsViewPanelOpen}
              setUserData={setUserData}
              userShiftGradeDetails={userShiftGradeDetails}
              setUserShiftGradeDetails={setUserShiftGradeDetails}
              trigger={trigger}
              setTrigger={setTrigger}
              setGradeData={setGradeData}
              page={page}
              setPage={setPage}
              headers={visibleHeaders}
            />
          ) : (
            <Mui.Grid sx={{ ml: 2, mr: 2 }}>
              <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
                <Mui.Table className="border">
                  <Mui.TableHead
                    sx={{
                      backgroundColor: themes.primary,
                      position: "sticky",
                      top: -1,
                      zIndex: 10,
                    }}
                  >
                    <Mui.TableRow sx={tableRowSize}>
                      <Mui.TableCell
                        key="action"
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                      />
                      {visibleHeaders?.map((value) => (
                        <Mui.TableCell
                          key={value.key}
                          sx={{
                            color: themes.headLine,
                            fontWeight: "bold",
                          }}
                        >
                          {value?.name}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>
                  <Mui.TableBody>
                    {shiftGradeDetails?.length === 0 ? (
                      <TableEmptyState dataLength={shiftData} />
                    ) : (
                      shiftGradeDetails
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        ?.map((value) => (
                          <>
                            <Mui.TableRow key={value.id} sx={tableRowSize}>
                              <Mui.TableCell key={`${value.id}-action`}>
                                {expendRowId === value.id ? (
                                  <Mui.IconButton
                                    onClick={() => setExpendRowId(0)}
                                    size="small"
                                    sx={{ ml: 2.5 }}
                                  >
                                    <KeyboardArrowDown sx={{ fontSize: 18 }} />
                                  </Mui.IconButton>
                                ) : (
                                  <Mui.IconButton
                                    onClick={() => {
                                      setExapandDetils([]);
                                      setExpendRowId(value.id);
                                      setExpandItem(value);
                                      setTriggerApi(true);
                                    }}
                                    size="small"
                                    sx={{ ml: 2.5 }}
                                  >
                                    <KeyboardArrowRight sx={{ fontSize: 18 }} />
                                  </Mui.IconButton>
                                )}
                              </Mui.TableCell>
                              {visibleHeaders.map((head) => (
                                <Mui.TableCell key={`${value.id}-${head.key}`}>
                                  {value[head.key] ? value[head.key] : "0"}
                                </Mui.TableCell>
                              ))}
                            </Mui.TableRow>
                            {expendRowId === value.id && (
                              <Mui.TableRow>
                                <Mui.TableCell colSpan={12}>
                                  <Mui.TableContainer
                                    sx={{
                                      marginTop: 0,
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                      width: "100%px",
                                    }}
                                    className="w-96 border rounded"
                                  >
                                    <Mui.Table>
                                      <Mui.TableHead
                                        sx={{
                                          backgroundColor: themes.primary,
                                        }}
                                      >
                                        <Mui.TableRow
                                          sx={{
                                            "& .MuiTableCell-root": {
                                              height: "6px",
                                              padding: "6px 10px",
                                            },
                                          }}
                                        >
                                          {IndividualUserShiftGradeDetails.map(
                                            (head) => (
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.headLine,
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {head.name}
                                              </Mui.TableCell>
                                            ),
                                          )}
                                        </Mui.TableRow>
                                      </Mui.TableHead>
                                      <Mui.TableBody>
                                        {individualLoader ? (
                                          <Mui.TableRow sx={tableRowSize}>
                                            <Mui.TableCell
                                              colSpan={10}
                                              style={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <CompanyProgress
                                                comLogo={comLogo}
                                                themes={themes}
                                              />
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ) : expandDetails.length === 0 &&
                                          !individualLoader ? (
                                          <Mui.TableRow
                                            maxWidth="xl"
                                            align="left"
                                            sx={tableRowSize}
                                          >
                                            <Mui.TableCell colSpan={12}>
                                              <Mui.Alert
                                                sx={{ marginTop: 3 }}
                                                severity="info"
                                              >
                                                No data available
                                              </Mui.Alert>
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ) : (
                                          expandDetails?.map((detail) => (
                                            <Mui.TableRow
                                              sx={{
                                                "& .MuiTableCell-root": {
                                                  height: "10px",
                                                  padding: "10px 10px",
                                                },
                                              }}
                                            >
                                              {IndividualUserShiftGradeDetails?.map(
                                                (head) =>
                                                  head?.key === "Action" ? (
                                                    <Mui.TableCell
                                                      key={head.key}
                                                    >
                                                      <RemoveRedEye
                                                        onClick={() => {
                                                          handleViewShiftGrade();
                                                          setUserData(detail);
                                                        }}
                                                        sx={{
                                                          cursor: "pointer",
                                                          color:
                                                            themes?.mutedgreen,
                                                        }}
                                                      />
                                                    </Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell
                                                      key={head.key}
                                                    >
                                                      {detail[head.key] ||
                                                      detail[head.key] === 0
                                                        ? detail[head.key]
                                                        : "N/A"}
                                                    </Mui.TableCell>
                                                  ),
                                              )}
                                            </Mui.TableRow>
                                          ))
                                        )}
                                      </Mui.TableBody>
                                    </Mui.Table>
                                  </Mui.TableContainer>
                                </Mui.TableCell>
                              </Mui.TableRow>
                            )}
                          </>
                        ))
                    )}
                  </Mui.TableBody>
                </Mui.Table>
              </Mui.TableContainer>
              <Box sx={{ mt: 1 }}>
                {shiftGradeDetails?.length > 25 && (
                  <Mui.TablePagination
                    className="custom-pagination"
                    component="div"
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    count={shiftGradeDetails?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            </Mui.Grid>
          )}
        </Paper>
      </Box>

      <Drawer
        anchor="right"
        open={isMovePanelOpen || isViewPanelOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          isMovePanelOpen ? handleCreateClosePanel() : handleViewClosePanel();
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: "680px",
            maxWidth: "90vw",
            backgroundColor: themes?.themes?.whiteColor,
          },
        }}
      >
        {isMovePanelOpen ? (
          <BulkAssignmentPanel
            onClose={handleCreateClosePanel}
            reCallApi={reCallApi}
            isShiftGradePanel={true}
            isShiftGroupPanel={false}
          />
        ) : isViewPanelOpen ? (
          <ViewAssignmentPanel
            onClose={handleViewClosePanel}
            userData={userData}
            reCallApi={reCallApi}
            setUpdateData={setUpdateData}
            screenAccess={
              showUserView ? employee_check_access : group_check_access
            }
          />
        ) : null}
      </Drawer>
    </React.Fragment>
  );
};
